@switch (tag()) {
  @case ('h1') {
    <h1>{{ text() }}</h1>
  }
  @case ('h2') {
    <h2>{{ text() }}</h2>
  }
  @case ('h3') {
    <h3>{{ text() }}</h3>
  }
  @case ('h4') {
    <h4>{{ text() }}</h4>
  }
  @case ('h5') {
    <h5>{{ text() }}</h5>
  }
  @case ('h6') {
    <h6>{{ text() }}</h6>
  }
}
